import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import './i18n';
import App from './App';
import { initSession } from './auth/session';
import { parseSubdomain } from './utils/subdomain';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));

function render() {
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>
  );
}

// Only the admin app has a login session; landing and storefront render right away.
if (parseSubdomain().type === 'admin') {
  initSession().finally(render);
} else {
  render();
}
